// @flow

export function IsLocalUrl(url: string): boolean {
  const link = document.createElement("a");
  link.href = url;

  const urlHost = link.hostname;
  const rootHost = window.location.hostname;

  return (urlHost === rootHost);
}